import script from "./MainHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MainHeader.vue?vue&type=script&setup=true&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=3dfb04c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dfb04c1"]])

export default __exports__